export const roomsInfo = [
  { title: 'студии', area: '40,95', active: true },
  { title: '1-комнатные', area: '50,95', active: false },
  { title: '2-комнатные', area: '60,95', active: false },
  { title: '3-комнатные', area: '70,95', active: false },
  { title: '4-комнатные', area: '80,95', active: false },
];

export const infoAboutProject = [
  {
    id: 1,
    title: 5,
    info: 'пешком до&nbsp;МЦК &laquo;Стрешнево&raquo;',
    infoMob: 'пешком до<br/>МЦК &laquo;Стрешнево&raquo;',
  },
  {
    id: 2,
    title: 15,
    info: 'пешком до&nbsp;ж/д станции &laquo;Стрешнево&raquo; (Д2)',
    infoMob: 'пешком до&nbsp;ж/д станции<br/>&laquo;Стрешнево&raquo; (Д2)',
  },
  {
    id: 3,
    title: 15,
    info: 'на&nbsp;автомобиле до&nbsp;Кремля',
    infoMob: 'на&nbsp;автомобиле<br/>до&nbsp;Кремля',
  },
  {
    id: 4,
    title: 11,
    info: 'на&nbsp;автомобиле до&nbsp;Белорусского вокзала',
    infoMob: 'на&nbsp;автомобиле до<br/>Белорусского&nbsp;вокзала',
  },
];

export const infoAboutLandscaping = [
  { id: 1, title: '2', info: 'Внутренних двора' },
  { id: 3, title: '100+', info: 'Видов озеленения' },
];
